import Microgame from '../engine/Microgame.js';

export default class DuckGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Baisse-toi !`, en: `Duck!`, es: `¡Agáchate!` },
            controls: { fr: `Maintiens ou appuie pour te baisser`, en: `Hold or tap to duck`, es: `Mantén o toca para agacharte` },
            objective: { fr: `Esquive les obstacles volants`, en: `Dodge the flying obstacles`, es: `Esquiva los obstáculos voladores` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" stroke-width="2"><path d="M12 2v4"/><path d="M12 18v4"/><path d="M4.93 4.93l2.83 2.83"/><path d="M16.24 16.24l2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="M4.93 19.07l2.83-2.83"/><path d="M16.24 7.76l2.83-2.83"/></svg>`,
            actions: [
                { type: 'wait', duration: 1200 },
                { type: 'hold', x: 30, y: 72, duration: 120, holdDuration: 260 },
                { type: 'wait', duration: 480 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.player = null;
        this.obstacle = null;
        this.isDucking = false;
        this.normalHeight = 100;
        this.duckHeight = 40;
        this.duckTimer = 0;
        this.maxDuckTime = 400; // ms maximum duck time
        this.duckExhausted = false;
    }

    setup() {
        this.engine.ui.instruction.textContent = "DUCK!";

        // Ground
        const ground = document.createElement('div');
        ground.style.position = 'absolute';
        ground.style.bottom = '50px';
        ground.style.width = '100%';
        ground.style.height = '2px';
        ground.style.background = this.secondaryColor;
        this.container.appendChild(ground);

        // Player
        this.player = document.createElement('div');
        this.player.style.position = 'absolute';
        this.player.style.width = '40px';
        this.player.style.height = `${this.normalHeight}px`;
        this.player.style.background = this.primaryColor;
        this.player.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.player.style.bottom = '52px';
        this.player.style.left = '20%';
        this.player.style.transition = 'height 0.1s';
        this.container.appendChild(this.player);

        // Obstacle (High Laser)
        this.obstacle = document.createElement('div');
        this.obstacle.style.position = 'absolute';
        this.obstacle.style.width = '20px';
        this.obstacle.style.height = '80px'; // High enough to hit standing player
        this.obstacle.style.background = this.secondaryColor;
        this.obstacle.style.boxShadow = `0 0 15px ${this.secondaryColor}`;
        this.obstacle.style.bottom = '110px'; // Raised to allow ducking (Player ducked top is ~92px)
        const randomDistance = this.isPlayback ? 120 : Math.random() * 300;
        this.obstacle.style.left = `${this.container.clientWidth + randomDistance}px`;
        this.container.appendChild(this.obstacle);

        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown() {
        if (!this.active || this.duckExhausted) return;
        this.isDucking = true;
        this.duckTimer = 0;
        this.player.style.height = `${this.duckHeight}px`;
    }

    onUp() {
        this.isDucking = false;
        this.duckExhausted = false;
        this.player.style.height = `${this.normalHeight}px`;
    }

    update(dt) {
        if (!this.active) return;

        // Anti-cheese: Force stand up if ducking too long
        if (this.isDucking) {
            this.duckTimer += dt;
            if (this.duckTimer >= this.maxDuckTime) {
                this.isDucking = false;
                this.duckExhausted = true;
                this.player.style.height = `${this.normalHeight}px`;
            }
        }

        // Move Obstacle
        const speedMult = this.engine.speedMultiplier || 1.0;
        const speed = 500 * speedMult;
        let obsLeft = parseFloat(this.obstacle.style.left) || this.container.clientWidth;
        obsLeft -= speed * (dt / 1000);
        this.obstacle.style.left = `${obsLeft}px`;

        if (obsLeft < -50) {
            // Passed successfully
            if (!this.won) {
                this.win();
            }
        }

        // Collision
        const pRect = this.player.getBoundingClientRect();
        const oRect = this.obstacle.getBoundingClientRect();

        const padding = 10;
        if (
            pRect.right - padding > oRect.left &&
            pRect.left + padding < oRect.right &&
            pRect.bottom - padding > oRect.top &&
            pRect.top + padding < oRect.bottom
        ) {
            this.lose();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
